import { SupportParams } from "@faire/help-center/consts";
import { useParams } from "react-router-dom";

export const useArticleId = () => {
  const articleId = useParams<SupportParams>().articleId;

  return articleId;
};
